import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  formContainer: {
    // Override FormInputRow description wrapper max-width for better layout
    '& .descriptionWrapper, & .MuiGrid-root.descriptionWrapper, & [class*="descriptionWrapper"]': {
      maxWidth: 'auto'
    },
    // Override MuiGrid-root margin-top to zero only for form elements, not banner content
    '& > .MuiGrid-root': {
      marginTop: 0,
      marginLeft: 0,
      marginRight: 0
    }
  },
  bannerContainer: {
    padding: spacing(3),
    backgroundColor: palette.background?.paper || '#fff',
    border: `1px solid ${palette.divider || '#e0e0e0'}`,
    borderRadius: spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: spacing(100), // 800px equivalent using theme spacing
    margin: '0 auto'
  },
  bannerContent: {
    marginTop: spacing(0),
    marginLeft: spacing(0)
  },
  bannerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(4),
    paddingBottom: spacing(2),
    borderBottom: `1px solid ${palette.divider || '#e0e0e0'}`,
    width: '100%',
    alignSelf: 'flex-start'
  },
  addBannerContainer: {
    textAlign: 'center',
    padding: spacing(2),
    backgroundColor: palette.grey?.[50] || '#f5f5f5',
    borderRadius: spacing(0.5),
    border: `2px dashed ${palette.divider || '#e0e0e0'}`
  },
  bannerGrid: {
    marginBottom: spacing(2),
    // Root-level style override for FormInputRow description wrapper
    // This overrides the default max-width of description text in form components
    marginTop: spacing(-2),
    marginLeft: spacing(-2),
    // Override default padding on large screens
    paddingTop: spacing(0), // 50px equivalent
    paddingLeft: spacing(0) // 40px equivalent
  },
  bannerTitle: {
    fontWeight: 500
  },
  imageSection: {
    marginTop: spacing(3)
  },
  imageTitle: {
    marginTop: spacing(4)
  },
  imageDivider: {
    marginTop: spacing(3)
  },
  addButton: {
    textTransform: 'none'
  }
}))
